export default "__VITE_ASSET__0O1dbBH7__"